import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
}

export const useGetInvoiceRemindersQuery = ({ customerId }: IProps) => useQuery(
  'GetInvoiceRemindersQuery',
  async () => {
    const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/invoice/reminders`);
    return res.data;
  },
  {
    enabled: true,
    retry: 2,
    refetchOnWindowFocus: false,
  },
);
